import { useSearchParams } from 'react-router-dom';

const MEDIA_VIEWER_MODE_PARAM = 'mode';
const MEDIA_VIEWER_APPROVAL_MODE = 'approval';

/**
 * Internal media viewer URL for an asset opened from an approval workflow.
 * In this mode the assets slider and breadcrumbs follow the approval
 * instead of the asset's campaign/folder.
 */
export function getApprovalMediaViewerUrl(assetId: string, versionId: string) {
  return `/media-viewer/${assetId}/${versionId}?${MEDIA_VIEWER_MODE_PARAM}=${MEDIA_VIEWER_APPROVAL_MODE}`;
}

export function useIsApprovalMediaViewerMode() {
  const [searchParams] = useSearchParams();
  return (
    searchParams.get(MEDIA_VIEWER_MODE_PARAM) === MEDIA_VIEWER_APPROVAL_MODE
  );
}
